import React, { useEffect, useState } from "react";
import "../../../Assets/CSS/bulkorder.css";
import "../oms.css";
import Up from "../../../Assets/Images/OMS/up.svg";
import Down from "../../../Assets/Images/OMS/down.svg";
import Mandi from "../../../Assets/Images/OMS_New/mandi (1).svg";
import CloseIcon from "@material-ui/icons/Close";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import ImageIcon from "@mui/icons-material/Image";
import { useFormik } from "formik";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Button,
} from "@mui/material";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import toast from "react-hot-toast";

import IconButton from "@material-ui/core/IconButton";
import ShowPDF from "../common/pdfViewer";
import { Modal } from "@material-ui/core";

function MandiDetailSupplier({ orderId, orderShipmentDocs, getOMSData, omsData }) {
  const isPending = omsData?.only_bnps?.ayekart_lvl1_status !== 'Approved' || omsData?.only_bnps?.ayekart_lvl2_status !== 'Approved';

  const [mandiTaxDetails, setMandiTaxDetails] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [transportDetails, setTransportDetails] = useState({});
  const [pdfUrl, setPdfUrl] = useState("");
  const [activeModal, setActiveModal] = useState(false);
  const [formDisable, setFormDisable] = useState(false);

  const [selectedPrimary9r, setSelectedPrimary9r] = useState([]);
  const [selectedDocument6r, setSelectedDocument6r] = useState([]);
  const [selectedPrimaryGatePass, setSelectedPrimaryGatePass] = useState([]);
  const [selectedSecondary9r, setSelectedSecondary9r] = useState([]);
  const [selectedSecondaryGatePass, setSelectedSecondaryGatePass] = useState(
    []
  );

  const [docState, setDocState] = useState({
    document_6r_oms: [],
    primary_9r_oms: [],
    primary_gate_pass_oms: [],
    secondary_9r_oms: [],
    secondary_gate_pass_oms: [],
  });

  const initialValues = {
    mandi_tax_paid_by_ayekart: null,
  };
  const validate = (values) => {
    const errors = {};

    return errors;
  };

  const handleModalClose = () => {
    setPdfUrl("");
    setActiveModal(false);
  };

  const handleModalOpen = (pdfUrl) => {
    setPdfUrl(pdfUrl);
    setActiveModal(true);
  };

  const handleSubmit = async (values) => {
    const payload = {
      order_id: orderId,
      merchant_type: "supplier",
      is_oms: true,
      mandi_tax_paid_by_ayekart: values.mandi_tax_paid_by_ayekart || null,
      document_6r_oms: docState.document_6r_oms,
      primary_9r_oms: docState.primary_9r_oms,
      primary_gate_pass_oms: docState.primary_gate_pass_oms,
      secondary_9r_oms: docState.secondary_9r_oms,
      secondary_gate_pass_oms: docState.secondary_gate_pass_oms,
    };

    try {
      const { data } = await axios.post("/api/oms/shipment/docs", payload);
      if (data.status) {
        formik.resetForm();
        getOMSData();
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(
        error.response ? error.response.data.message : "An error occured"
      );
    }
  };

  const setInvoice = (fileLocation, event) => {
    switch (event.target.name) {
      case "document_6r_oms":
        setDocState((prev) => ({
          ...prev,
          document_6r_oms: [...prev.document_6r_oms, fileLocation],
        }));

        break;
      case "primary_9r_oms":
        setDocState((prev) => ({
          ...prev,
          primary_9r_oms: [...prev.primary_9r_oms, fileLocation],
        }));

        break;
      case "primary_gate_pass_oms":
        setDocState((prev) => ({
          ...prev,
          primary_gate_pass_oms: [...prev.primary_gate_pass_oms, fileLocation],
        }));

        break;
      case "secondary_9r_oms":
        setDocState((prev) => ({
          ...prev,
          secondary_9r_oms: [...prev.secondary_9r_oms, fileLocation],
        }));

        break;
      case "secondary_gate_pass_oms":
        setDocState((prev) => ({
          ...prev,
          secondary_gate_pass_oms: [
            ...prev.secondary_gate_pass_oms,
            fileLocation,
          ],
        }));

        break;
    }
  };

  const onFileChange = async (event, setUrl) => {
    switch (event.target.name) {
      case "document_6r_oms":
        setDocState((prev) => ({
          ...prev,
          document_6r_oms: transportDetails?.document_6r_oms || [],
        }));

        break;
      case "primary_9r_oms":
        setDocState((prev) => ({
          ...prev,
          primary_9r_oms: transportDetails?.primary_9r_oms || [],
        }));

        break;
      case "primary_gate_pass_oms":
        setDocState((prev) => ({
          ...prev,
          primary_gate_pass_oms: transportDetails?.primary_gate_pass_oms || [],
        }));

        break;
      case "secondary_9r_oms":
        setDocState((prev) => ({
          ...prev,
          secondary_9r_oms: transportDetails?.secondary_9r_oms || [],
        }));

        break;
      case "secondary_gate_pass_oms":
        setDocState((prev) => ({
          ...prev,
          secondary_gate_pass_oms:
            transportDetails?.secondary_gate_pass_oms || [],
        }));
        break;
    }
    const files = event.target.files;

    if (files.length > 0) {
      setUploading(true);

      const uploadPromises = Array.from(files).map(async (file) => {
        const formData = new FormData();
        formData.append("file", file);

        try {
          const uploadResponse = await fetch(
            "/upload/mitra-merchant/doc-upload",
            {
              method: "POST",
              body: formData,
            }
          );

          if (uploadResponse.ok) {
            const uploadResponseData = await uploadResponse.json();
            setUrl(uploadResponseData.file_location, event);
          } else {
            throw new Error("Failed to upload file.");
          }
        } catch (error) {
          setUploading(false);
          console.error("Error uploading file:", error);
        }
      });

      try {
        await Promise.all(uploadPromises);
        setUploading(false);
      } catch (error) {
        setUploading(false);
        console.error("Error uploading files:", error);
      }
    }
  };

  const handleSecondary9r = (index) => {
    const newState = [...docState.secondary_9r_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      secondary_9r_oms: newState,
    }));
  };
  const handleDeleteDocument6r = (index) => {
    const newState = [...docState.document_6r_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      document_6r_oms: newState,
    }));
  };
  const handleDeletePrimary9r = (index) => {
    const newState = [...docState.primary_9r_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      primary_9r_oms: newState,
    }));
  };
  const handlePrimaryGatePass = (index) => {
    const newState = [...docState.primary_gate_pass_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      primary_gate_pass_oms: newState,
    }));
  };
  const handleSecondaryGatePass = (index) => {
    const newState = [...docState.secondary_gate_pass_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      secondary_gate_pass_oms: newState,
    }));
  };

  const formik = useFormik({
    initialValues: initialValues,
    validate,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    const transport = orderShipmentDocs?.find(
      (obj) => obj.merchant_type === "supplier"
    );

    if (transport) {
      setFormDisable(true);
    } else {
      setFormDisable(false);
    }

    if (transport) {
      setTransportDetails(transport);
      setDocState((prev) => ({
        ...prev,
        primary_9r_oms: transport?.primary_9r_oms || [],
        document_6r_oms: transport?.document_6r_oms || [],
        primary_gate_pass_oms: transport?.primary_gate_pass_oms || [],
        secondary_9r_oms: transport?.secondary_9r_oms || [],
        secondary_gate_pass_oms: transport?.secondary_gate_pass_oms || [],
      }));

      formik.setValues({
        ...formik.values,
        mandi_tax_paid_by_ayekart: transport?.mandi_tax_paid_by_ayekart || null,
      });
    }
  }, [orderShipmentDocs, formik.setValues]);

  return (
    <>
      <Modal
        open={activeModal}
        onClose={handleModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            width: "50%",
            height: "80%",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            overflowY: "auto",
          }}
        >
          <div className="">
            <IconButton
              aria-label="close"
              style={{ position: "absolute", right: "8px", top: "8px" }}
              onClick={handleModalClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="flex flex-col items-center justify-center space-y-5 h-full">
            {pdfUrl?.toLowerCase().endsWith(".pdf") ? (
              <ShowPDF pdfUrl={pdfUrl} />
            ) : (
              <img src={pdfUrl} alt="uploaded image" />
            )}
          </div>
        </Box>
      </Modal>

      <div className="shadow-lg m-2 p-2 pb-2 rounded-lg">
        <div className="flex flex-col sm:flex-row justify-between">
          <div className="font-medium text-cyan-950 text-md flex gap-1">
            <img src={Mandi} alt="" />
            <div className="ms-1">Mandi Tax Documentation</div>
          </div>
          <div>
            {mandiTaxDetails ? (
              <div className="font-medium text-cyan-950 text-lg mt-2">
                <img
                  src={Up}
                  alt=""
                  role="button"
                  onClick={() => setMandiTaxDetails(!mandiTaxDetails)}
                />
              </div>
            ) : (
              <div className="font-medium text-cyan-950 text-lg mt-2">
                <img
                  src={Down}
                  alt=""
                  role="button"
                  onClick={() => setMandiTaxDetails(!mandiTaxDetails)}
                />
              </div>
            )}
          </div>
        </div>
        <div>
          <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
        </div>
        <div>
          {mandiTaxDetails ? (
            <></>
          ) : (
            <div>
              <form onSubmit={formik.handleSubmit}>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-1 gap-4">
                  <div class="mb-3 relative">
                    <label
                      for="mandi_tax_paid_by_ayekart"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Mandi Tax (Paid By Ayekart) (Rs)
                    </label>

                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="mandi_tax_paid_by_ayekart"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-25 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="mandi_tax_paid_by_ayekart"
                      placeholder="Enter Mandi Tax"
                      value={formik.values.mandi_tax_paid_by_ayekart}
                      onChange={formik.handleChange}
                      step="any"
                      disabled={isPending}
                    />
                    {formik.errors.mandi_tax_paid_by_ayekart ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.mandi_tax_paid_by_ayekart}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-2 text-center ">
                  <h1 className="text-2xl text-blue-900 flex justify-start ">
                    Documents
                  </h1>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span>6R Document</span>
                      </div>
                      {docState.document_6r_oms.length === 0 ? (
                        <div>
                        <div>
                          <i
                            class="fa fa-file-pdf-o fs-1 text-secondary"
                            aria-hidden="true"
                          ></i>
                        </div>
                        <span className="p-1 bg-red-200 rounded mb-2">
                          <span style={{ color: "#fc3503" }}>
                            Not Uploaded
                          </span>
                        </span>
                      </div>
                      ) : (
                        docState.document_6r_oms.map((each, index) => (
                          <div key={index} className="border-2">
                            <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div
                                onClick={() => handleDeleteDocument6r(index)}
                              >
                                <DeleteIcon />
                              </div>
                            </div>
                            {(each?.toLowerCase().endsWith(".jpg") ||
                              each?.toLowerCase().endsWith(".png") ||
                              each?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {each?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={each}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                      <input
                        id="file"
                        type="file"
                        name="document_6r_oms"
                        onChange={(e) => {
                          onFileChange(e, setInvoice);
                          setSelectedDocument6r([...e.target.files]);
                        }}
                        className="mt-5"
                        disabled={isPending || uploading}
                        multiple
                      />
                      {selectedDocument6r.length > 0 && (
                        <div className="mt-2 p-2">
                          <p>Selected files:</p>
                          <ul className="list-decimal">
                            {selectedDocument6r.map((file, index) => (
                              <li key={index} className="font-bold text-sm">
                                {file.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    {formik.errors.document_6r_oms ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.document_6r_oms}
                      </div>
                    ) : null}
                  </div>
                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span>Primary 9R</span>
                      </div>
                      {docState.primary_9r_oms.length === 0 ? (
                        <div>
                        <div>
                          <i
                            class="fa fa-file-pdf-o fs-1 text-secondary"
                            aria-hidden="true"
                          ></i>
                        </div>
                        <span className="p-1 bg-red-200 rounded mb-2">
                          <span style={{ color: "#fc3503" }}>
                            Not Uploaded
                          </span>
                        </span>
                      </div>
                      ) : (
                        docState.primary_9r_oms.map((each, index) => (
                          <div key={index} className="border-2">
                            <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div onClick={() => handleDeletePrimary9r(index)}>
                                <DeleteIcon />
                              </div>
                            </div>
                            {(each?.toLowerCase().endsWith(".jpg") ||
                              each?.toLowerCase().endsWith(".png") ||
                              each?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {each?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={each}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                      <input
                        id="file"
                        type="file"
                        name="primary_9r_oms"
                        onChange={(e) => {
                          onFileChange(e, setInvoice);
                          setSelectedPrimary9r([...e.target.files]);
                        }}
                        className="mt-5"
                        disabled={isPending || uploading}
                        multiple
                      />
                      {selectedPrimary9r.length > 0 && (
                        <div className="mt-2 p-2">
                          <p>Selected files:</p>
                          <ul className="list-decimal">
                            {selectedPrimary9r.map((file, index) => (
                              <li key={index} className="font-bold text-sm">
                                {file.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span>Primary Gate Pass</span>
                      </div>

                      {docState.primary_gate_pass_oms.length === 0 ? (
                        <div>
                        <div>
                          <i
                            class="fa fa-file-pdf-o fs-1 text-secondary"
                            aria-hidden="true"
                          ></i>
                        </div>
                        <span className="p-1 bg-red-200 rounded mb-2">
                          <span style={{ color: "#fc3503" }}>
                            Not Uploaded
                          </span>
                        </span>
                      </div>
                      ) : (
                        docState.primary_gate_pass_oms.map((each, index) => (
                          <div key={index} className="border-2">
                            <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div onClick={() => handlePrimaryGatePass(index)}>
                                <DeleteIcon />
                              </div>
                            </div>
                            {(each?.toLowerCase().endsWith(".jpg") ||
                              each?.toLowerCase().endsWith(".png") ||
                              each?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {each?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={each}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}

                      <input
                        id="file"
                        type="file"
                        name="primary_gate_pass_oms"
                        className="mt-5"
                        onChange={(e) => {
                          onFileChange(e, setInvoice);
                          setSelectedPrimaryGatePass([...e.target.files]);
                        }}
                        disabled={isPending || uploading}
                        multiple
                      />
                      {selectedPrimaryGatePass.length > 0 && (
                        <div className="mt-2 p-2">
                          <p>Selected files:</p>
                          <ul className="list-decimal">
                            {selectedPrimaryGatePass.map((file, index) => (
                              <li key={index} className="font-bold text-sm">
                                {file.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    {formik.errors.primary_gate_pass_oms ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.primary_gate_pass_oms}
                      </div>
                    ) : null}
                  </div>
                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span>Secondary 9R</span>
                      </div>
                      {docState.secondary_9r_oms.length === 0 ? (
                        <div>
                        <div>
                          <i
                            class="fa fa-file-pdf-o fs-1 text-secondary"
                            aria-hidden="true"
                          ></i>
                        </div>
                        <span className="p-1 bg-red-200 rounded mb-2">
                          <span style={{ color: "#fc3503" }}>
                            Not Uploaded
                          </span>
                        </span>
                      </div>
                      ) : (
                        docState.secondary_9r_oms.map((each, index) => (
                          <div key={index} className="border-2">
                            <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div onClick={() => handleSecondary9r(index)}>
                                <DeleteIcon />
                              </div>
                            </div>
                            {(each?.toLowerCase().endsWith(".jpg") ||
                              each?.toLowerCase().endsWith(".png") ||
                              each?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {each?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={each}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}

                      <input
                        id="file"
                        type="file"
                        name="secondary_9r_oms"
                        onChange={(e) => {
                          onFileChange(e, setInvoice);
                          setSelectedSecondary9r([...e.target.files]);
                        }}
                        className="mt-5"
                        disabled={isPending || uploading}
                        multiple
                      />
                      {selectedSecondary9r.length > 0 && (
                        <div className="mt-2 p-2">
                          <p>Selected files:</p>
                          <ul className="list-decimal">
                            {selectedSecondary9r.map((file, index) => (
                              <li key={index} className="font-bold text-sm">
                                {file.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    {formik.errors.driver_photo ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.driver_photo}
                      </div>
                    ) : null}
                  </div>
                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span>Secondary Gate Pass</span>
                      </div>

                      {docState.secondary_gate_pass_oms.length === 0 ? (
                        <div>
                        <div>
                          <i
                            class="fa fa-file-pdf-o fs-1 text-secondary"
                            aria-hidden="true"
                          ></i>
                        </div>
                        <span className="p-1 bg-red-200 rounded mb-2">
                          <span style={{ color: "#fc3503" }}>
                            Not Uploaded
                          </span>
                        </span>
                      </div>
                      ) : (
                        docState.secondary_gate_pass_oms.map((each, index) => (
                          <div key={index} className="border-2">
                            <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div
                                onClick={() => handleSecondaryGatePass(index)}
                              >
                                <DeleteIcon />
                              </div>
                            </div>
                            {(each?.toLowerCase().endsWith(".jpg") ||
                              each?.toLowerCase().endsWith(".png") ||
                              each?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {each?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={each}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}

                      <input
                        id="file"
                        type="file"
                        name="secondary_gate_pass_oms"
                        onChange={(e) => {
                          onFileChange(e, setInvoice);
                          setSelectedSecondaryGatePass([...e.target.files]);
                        }}
                        className="mt-5"
                        disabled={isPending || uploading}
                        multiple
                      />

                      {selectedSecondaryGatePass.length > 0 && (
                        <div className="mt-2 p-2">
                          <p>Selected files:</p>
                          <ul className="list-decimal">
                            {selectedSecondaryGatePass.map((file, index) => (
                              <li key={index} className="font-bold text-sm">
                                {file.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    {formik.errors.driver_license ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.driver_license}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div>
                  {uploading ? (
                    <div>
                      <ClipLoader />
                    </div>
                  ) : (
                    <div className="flex justify-end mt-2">
                      {/*<Button 
                            color="error"
                            onClick={(e) => formik.resetForm()}
                          >
                            CLEAR
                          </Button>*/}
                      <Button
                        variant="contained"
                        size="small"
                        type="submit"
                        sx={{ backgroundColor: "#0D9223" }}
                        disabled={isPending}
                      >
                        SAVE
                      </Button>
                    </div>
                  )}
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default MandiDetailSupplier;
